export enum LABELS_PERMISSIONS {
  LABELS_VIEW = 'LABELSCONFIGURATION_VIEW',
  LABELS_WRITE = 'LABELSCONFIGURATION_WRITE',
}
